// removed by extract-text-webpack-plugin
module.exports = {"datepicker":"_2tyS3","inline":"_1HAX0","header":"_1KFwl","nav":"_1-F5D","monthLabels":"_23Nfm","monthLabel":"YHcrd","monthYear":"DDRZC","body":"_3GSLm","month":"_6PZe_","weekdays":"_3D2Sh","weekday":"_1BPGk","week":"_2-dqk","placeholder":"_3kMob","day":"TS5ZD","outside":"xRYqA","today":"_1D5wz","disabled":"_1qNFW","inRange":"-N31w","start":"_3uhOF","end":"wjN4U"};


//////////////////
// WEBPACK FOOTER
// ./src/components/V2/datepicker/styles.module.css
// module id = 213
// module chunks = 0